var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIndividual3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.111,
    height: 30,
    viewBox: "0 0 26.111 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#7097f6;}.d{fill:#1855f1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26.112,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.686,30.135a.49.49,0,0,1-.244-.065l-10.054-5.8a.487.487,0,0,1-.244-.423V12.232a.488.488,0,0,1,.244-.423L15.442,6a.488.488,0,0,1,.489,0l10.053,5.8a.488.488,0,0,1,.244.423V23.841a.487.487,0,0,1-.244.423l-10.053,5.8a.489.489,0,0,1-.244.065M6.121,23.559l9.565,5.522,9.565-5.522V12.514L15.686,6.992,6.121,12.514Z",
    transform: "translate(-2.63 -3.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.947,30.4a.484.484,0,0,1-.244-.065l-5.027-2.9a.487.487,0,0,1-.244-.423v-5.8a.487.487,0,0,1,.244-.423l5.027-2.9a.488.488,0,0,1,.489,0l5.026,2.9a.487.487,0,0,1,.244.423v5.8a.487.487,0,0,1-.244.423l-5.026,2.9a.484.484,0,0,1-.244.065m-4.538-3.673,4.538,2.62,4.538-2.62V21.49l-4.538-2.62-4.538,2.62Z",
    transform: "translate(-7.89 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.576,30.539a.489.489,0,0,1-.244-.065l-2.514-1.451a.487.487,0,0,1-.244-.423V25.7a.488.488,0,0,1,.244-.423l2.514-1.451a.49.49,0,0,1,.489,0l2.513,1.451a.488.488,0,0,1,.244.423v2.9a.487.487,0,0,1-.244.423l-2.513,1.451a.491.491,0,0,1-.244.065m-2.025-2.222,2.025,1.169L25.6,28.317V25.979L23.576,24.81l-2.025,1.169Z",
    transform: "translate(-10.52 -12.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18.316,30.269a.484.484,0,0,1-.244-.065L10.531,25.85a.487.487,0,0,1-.244-.423V16.721a.487.487,0,0,1,.244-.423l7.541-4.353a.485.485,0,0,1,.489,0L26.1,16.3a.487.487,0,0,1,.244.423v8.707a.487.487,0,0,1-.244.423L18.561,30.2a.485.485,0,0,1-.244.065m-7.052-5.124,7.052,4.071,7.051-4.071V17l-7.051-4.071L11.264,17Z",
    transform: "translate(-5.26 -6.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M13.056,30a.489.489,0,0,1-.244-.065L.244,22.679A.487.487,0,0,1,0,22.256V7.744a.488.488,0,0,1,.244-.423L12.812.065a.488.488,0,0,1,.489,0L25.867,7.321a.489.489,0,0,1,.244.423V22.256a.488.488,0,0,1-.244.423L13.3,29.934a.49.49,0,0,1-.244.065M.977,21.974l12.079,6.973,12.078-6.973V8.026L13.056,1.053.977,8.026Z",
    transform: "translate(0 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividual3);
export default __webpack_public_path__ + "static/media/Icon-individual-3.197f3e4b1eec7fc8b61f561138810ad8.svg";
export { ForwardRef as ReactComponent };